import { StormTracksService } from '../../services/stormTracks/stormTracks';
import React, { useContext, useEffect, useState } from 'react';
import { Marker, useMap, useMapEvents } from 'react-leaflet';
import { DivIcon, LatLng } from 'leaflet';
import loadingContext from '../../context/loadingContext';
import Modal from '../modal/Modal';
import './StormTracks.css';
import { useSearchParams } from 'react-router-dom';
import StormTracksContent from './StormTracksContent';

export const StormTracks = () => {

    const [searchParams, setSearchParams] = useSearchParams();
    const map = useMap();
    const [markers, setMarkers] = useState<any[]>([]);
    const [tracks, setTracks] = useState<any>(null);
    const [trackCanvas, setTrackCanvas] = useState<any>(null);
    const key = searchParams.get("key");
    const service = new StormTracksService(map, key);
    const setLoading = useContext(loadingContext)
    const [isModalWindowOpen, setIsModalWindowOpen] = useState(false);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [currentStormTracks, setCurrentStormTracks] = useState<any>();


    const init = async () => {
        setLoading(true);
        const storm_tracks= await service.getStormTracks();
        setTracks(storm_tracks);
        getMarkers(storm_tracks);
        setLoading(false);
    }
    
    const getMarkers = (storm_tracks: any) => {
        const markers = service.getMarkers(storm_tracks);
        setMarkers(markers);
    }
    
    useMapEvents({
        zoom: (event) => {
            setTrackCanvas(null);
            getMarkers(tracks);
        },
        move: (event) => {
            getMarkers(tracks);
        }
    })
    const adjustPositionForModal = (latlng: LatLng, modalWidth: number, map: any, zoomLevel: number): LatLng => {
        const point = map.latLngToContainerPoint(latlng);
        const scaleFactor = Math.pow(2, zoomLevel - 9); // Ajusta el factor de escala según el nivel de zoom
        const adjustedPoint = point.subtract([((modalWidth / 2)+50) * scaleFactor, 0]);
        return map.containerPointToLatLng(adjustedPoint);
    };
    
    const handleMarkerClick = (marker: any) => {
        if (isModalLoading) return;
        setIsModalWindowOpen(true);
        setIsModalLoading(true);
        const currentLatLng = marker.position;
        const currentZoom = map.getZoom();
        // Below modal width is taked fixed (400) based on modal component
        const adjustedLatLng = adjustPositionForModal(currentLatLng, 400, map, currentZoom);
        map.setView(adjustedLatLng, 9).once('moveend', () => {
            service.updateLatLngData();
            const elementIcon = document.querySelector('.storm-track-icon')
            const iconSize = {
                width: elementIcon?.clientWidth ?? 30,
                height: elementIcon?.clientHeight ?? 30,
            }
            const track = service.drawTrack(marker.track, iconSize);
            const canvasIcon = new DivIcon({
                className: 'canvas-icon',
                html: track.canvas
            });
            setTrackCanvas({position: track.position, icon: canvasIcon });
        });
        setIsModalLoading(false);
        setCurrentStormTracks(marker);
    }

    const handleModalClose = () => {
        setIsModalWindowOpen(false);
        setCurrentStormTracks(null);
    };
    
    useEffect(() => {
        init();
    },[]);
    
    return (
        <>
            {trackCanvas && <Marker position={trackCanvas.position} zIndexOffset={100} icon={trackCanvas.icon} />}
            {
                isModalWindowOpen && (
                    <Modal
                        title={"STORM TRACK"}
                        isOpen={isModalWindowOpen}
                        onClose={handleModalClose}
                        size='small'
                    >
                        <StormTracksContent {...currentStormTracks} />
                    </Modal>
                )
            }
            {
                markers.map((marker, index) => {

                    const eventHandlers = {
                        click: () => handleMarkerClick(marker),
                        keydown: (e: any) => {
                            if (e.originalEvent.key === 'Enter' || e.originalEvent.keyCode === 13) {
                                handleMarkerClick(marker);
                            }
                        }
                    }

                    return (
                        <React.Fragment key={index}>
                            <Marker
                                position={marker.position}
                                icon={marker.icon}
                                eventHandlers={eventHandlers}
                            />
                        </React.Fragment>
                    )
                })
            }
        </>
    );
}
